import React, { useMemo } from "react";
import {
  useToast as useChakraToast,
  UseToastOptions as ChakraUseToastOptions,
} from "@chakra-ui/react";
import Toast, { ToastProps } from "./Toast";

interface UseToastOptions
  extends Omit<
      ChakraUseToastOptions,
      "title" | "description" | "status" | "position" | "variant" | "size"
    >,
    ToastProps {}

export const useToast = () => {
  const toast = useChakraToast();

  const showToast = useMemo(() => {
    const hook = (options: UseToastOptions) => {
      const {
        id,
        duration = 5000,
        onCloseComplete,
        ...toastProps
      } = options;
      return toast({
        id,
        duration,
        onCloseComplete,
        render: ({ onClose }) => (
          <Toast {...toastProps} onClose={onClose} />
        ),
      });
    };
    hook.close = toast.close;
    return hook;
  }, [toast]);

  return showToast;
};
